import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';

import { LARGE_CUSTOM_TRAY_SKU, MEDIUM_CUSTOM_TRAY_SKU } from '@/lib/customizers/trays';
import { productViewed } from '@/rudder-typer';
import analytics, { gtag } from '@/utils/analytics';
import { Taggstar } from '@/utils/analytics/taggstar';
import { Money } from '@/utils/money';
import { toLegacySku } from '@/utils/product';

interface NutsProductViewed {
  allBackordered?: boolean;
  cost?: Money;
  coupon?: string | null;
  discount?: Money;
  eventLocation?: string;
  indexName?: string;
  itemListName?: string;
  name: string;
  price: Money;
  priceBeforeDiscount?: Money;
  productId: string;
  quantity?: number;
  reportingCategory?: string;
  sku: string;
  unitName?: string | null;
  variantName?: string;
  weight?: number;
}

export function sendProductViewedEvent({
  allBackordered,
  cost,
  coupon,
  discount,
  eventLocation = '',
  indexName,
  itemListName = '',
  name,
  price,
  priceBeforeDiscount,
  productId,
  quantity,
  reportingCategory,
  sku,
  unitName,
  variantName,
  weight,
}: NutsProductViewed) {
  analytics.sendEvent('productDetail', eventLocation, {
    ecommerce: {
      detail: {
        actionField: { list: itemListName },
        products: [
          {
            id: toLegacySku(sku),
            name,
            itemExternalId: productId,
            unitName,
            price: dollars(price),
          },
        ],
      },
    },
  });

  gtag('event', 'view_item', {
    currency: 'USD',
    items: [
      {
        cost: cost ? dollars(cost) : undefined,
        coupon,
        discount: discount ? dollars(discount) : 0,
        indexName: indexName ?? null,
        item_id: productId,
        item_list_name: itemListName,
        item_name: name,
        item_variant: sku,
        item_variant_name: variantName,
        price: dollars(price),
        price_before_discount: priceBeforeDiscount ? dollars(priceBeforeDiscount) : undefined,
        quantity,
        reporting_category: reportingCategory,
        weight,
      },
    ],
    value: dollars(price),
  });

  productViewed({
    coupon: coupon ?? undefined,
    currency: 'USD',
    name,
    price: dollars(price),
    product_id: productId,
    quantity,
    reporting_category: reportingCategory,
    sku,
    variant: variantName,
  });

  if (![MEDIUM_CUSTOM_TRAY_SKU, LARGE_CUSTOM_TRAY_SKU].includes(sku)) {
    Taggstar.productVisit({
      category: reportingCategory,
      id: productId,
      name,
      oos: !!allBackordered,
      price: dollars(price),
    });
  }
}
